import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import AssistanceAddModal from '../../components/assistance/AssistanceAddModal'
import { createAssistance } from '../../state/actions/assistance'
import { IAssistanceObject, IStoreState } from '../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<any>) {
  return {
    categories: Object.values(state.assistanceCategories.items),
    onClose: ownProps.history.goBack
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    onCreateClick: (assistance: IAssistanceObject) => {
      return dispatch(createAssistance(assistance))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssistanceAddModal)



// WEBPACK FOOTER //
// ./src/containers/assistance/AssistanceAddModal.ts